import isEmpty from "lodash/isEmpty";
import orderBy from "lodash/orderBy";

export const sortSavedSearchesByDateCreated = (savedSearches) => {
    let sortedObj = {};
    if (!isEmpty(savedSearches) && Object.keys(savedSearches).length > 0) {
      const dataArray = orderBy(Object.values(savedSearches), ["dateCreated"], ["desc"]);
      const sortedArray = [];
      dataArray.forEach((value) => {
        const key = Object.keys(savedSearches).find((key) => savedSearches[key] === value);
        const obj = [key, value];
        sortedArray.push(obj as never);
      });
      sortedObj = Object.fromEntries(sortedArray);
    }
    return sortedObj;
};